import { OK } from 'http-status-codes'

import getAxiosInstance from '../../helpers/get_axios_instance'

export class ReportePorCerealService {
  static async getReporteDeCerealDetallado (cereal) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_detalle_espacio_silo_cereal?r={"clave":{"cereal":"${cereal}"}}`)
    return promise.then(result => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte por cereal.')
      return data
    })
  }

  static async getReporteDeCerealTotales (cereal) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_total_espacio_por_cereal?r={"clave":{"cereal":"${cereal}"}}`)
    return promise.then(result => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte por cereal.')
      return data
    })
  }
}
